<template>
  <div class="form-content">
    <div class="login-steps">
      <p class="title-form">Acceso a mi escritorio</p>
      <form @submit.prevent="handleSubmit">
        <Input :submitted="submitted" v-on:inputChange="handleChange"/>
        <InputPassword :submitted="submitted" v-on:inputChangePassword="handleChangePassword"/>
        <ButtonSolidMain :loading="loading" />
        <div v-if="error" class="alert-danger">{{ error }}</div>
      </form>
    </div>
  </div>
</template>

<script>
import ButtonSolidMain from "./ButtonSolidMain.vue";
import Input from "./Input.vue";
import InputPassword from "./InputPassword.vue";
import { router } from "../_helpers";
import { userService } from "../_services/user.service";
import MD5 from "crypto-js/md5";

export default {
  components: { Input, InputPassword, ButtonSolidMain },
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      loading: false,
      returnUrl: "",
      error: "",
      visibility: false,
    };
  },
  computed: {
    icon() {
      return this.visibility ? "visible.svg" : "not-visible.svg";
    },
  },
  created() {
    userService.logout();
    this.returnUrl = this.$route.query.returnUrl || "/";
  },
  methods: {
    handleSubmit() {
      
      this.submitted = true;

      const { username, password } = this;
      if (!(username && password)) return;
      this.loading = true;

      userService.login(username, MD5(password).toString()).then(
        (user) => {
          router.push(this.returnUrl + "?utm_source=" + user.source + "&utm_medium=" +
                user.id_shop +
                "&utm_campaign=" +
                user.id_user)
          },
        (error) => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    setVisibility() {
      this.visibility = !this.visibility;
    },
    handleChange(event) {
        this.username = event.target.value;
    },
    handleChangePassword(event) {
        this.password = event.target.value;
    }
  },
};
</script>

<style lang="scss">

@import "../../core/core-framework/assets/scss/inc/mixins/_text_mixins.scss";
@import "../../core/core-framework/assets/scss/inc/_variables.scss";
@import "../../core/core-framework/assets/scss/inc/_bootstrap_custom_variables.scss";
@import "../../core/core-framework/assets/scss/inc/mixins/mixins";
@import "../../core/core-framework/assets/scss/inc/_buttons";
@import "../../core/core-framework/assets/scss/inc/_inputs";


.login-steps {
  position: fixed;
  top: 43%;
  left: 50%;
  width: 30em;
  height: 18em;
  margin-top: -9em;
  margin-left: -15em;
}
.img-loading {
  margin: 30px auto;
  display: flex;
}
.invalid-feedback {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 80%;
  font-weight: 600;
  color: $color-red-01;
}
.form-control {
  border: none;
  padding: 0;
  margin-bottom: 8px;
  input {
    &.is-invalid {
    border: 2px solid $color-red-01;
    label {
      margin-bottom: 0;
    }
  }
}
}
.form-control.input label { margin-bottom: 4px; }
@media screen and (min-width: $screen-sm) {
.form-control.input input { padding: 16px 14px 12px 20px; } 
}
div.form-control.input.password {
  position: relative;
  &.with-security-check {
    margin-bottom: 8px;
  }
  .password-visibility {
    @include position($position: absolute, $top: 16px, $right: 12px);
    color: $color-grey-03;
    cursor: pointer;
  }
}
.title-form {
  text-align: center;
  font-size: 23px;
  font-weight: 600;
  line-height: 1.3;
  color: $color-black;
}
@media screen and(min-width: $screen-sm){
  .btn.solid-main {
    padding: 11px 141px 11px 144px;
    min-height: unset;
  }
}
.alert-danger {
  color: #A70000;
  font-weight: 600;
  background-color: #ffa7a79c;
  text-align: center;
  border-radius: 4px;
  margin-top: 11px;
  padding: 14px 1px;
}
</style>